/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import classnames from "classnames";
import { default as ReactSelect } from "react-select";

import "./Select.scss";
import styles from "./Select.module.scss";
import WithPropsGuard from "../util/WithPropsGuard";

export interface OptionType {
  label: string;
  value: string;
}

interface Props {
  options: OptionType[];
  onChange: (selectedValue: unknown) => void;
  placeholder: string;
  value?: string | number;
  isLoading?: boolean;
  className?: string;
  isMulti?: boolean;
  disabled?: boolean;
  defaultValue?: OptionType | OptionType[];
  isError?: boolean;
  errorMessage?: string;
}

const Select = WithPropsGuard(
  class Selects extends React.Component<Props> {
    static defaultProps = {
      disabled: false,
    };

    render() {
      const {
        options,
        onChange,
        className,
        isLoading,
        isMulti,
        disabled,
        defaultValue,
        isError,
        errorMessage,
        placeholder,
      } = this.props;
      return (
        <div className={classnames(className, styles.container)}>
          <ReactSelect
            classNamePrefix="react-select"
            options={options}
            onChange={onChange}
            isMulti={isMulti}
            defaultValue={defaultValue}
            isLoading={isLoading}
            isDisabled={disabled || isError}
            className={classnames(styles.select, isError ? styles.error : null)}
            placeholder={placeholder}
          />
          {isError && !!errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        </div>
      );
    }
  },
  (prevProps, nextProps) => prevProps.options.toString() !== nextProps.options.toString()
);

export default Select;
